/* Compagnons de Cœur — Atelier cart bridge (schema 4). Pushed to the theme with the opening of the Lot 2 (go of 01/10/2026).
 * The Atelier iframe sends { type: 'cdc-atelier-cart-add', version: 1, requestId, creationId, intentToken }.
 * This page (shop origin) resolves the one-shot token, adds the signed line, re-reads /cart.js and answers
 * { type: 'cdc-atelier-cart-result', version: 1, requestId, status: added | already_in_cart | rejected | failed }.
 * « Ajouter un deuxième exemplaire » (E13): { type: 'cdc-atelier-cart-increment', version: 1, requestId, creationId } raises the
 * quantity of that signed line by one (at most 10, the textile maximum; the order check holds anything above the profile's maximum)
 * and answers { type: 'cdc-atelier-cart-increment-result', version: 1, requestId, status: incremented | max | not_in_cart | failed, quantity }.
 * Sac cadeau réutilisable (mission 2026-10-06-13) : { type: 'cdc-atelier-gift-bag-query', version: 1, requestId } is answered with
 * { type: 'cdc-atelier-gift-bag-info', version: 1, requestId, available, priceCents, inCart } (window.CDCGiftBag, snippets/cdc-sac-cadeau.liquid:
 * set only while the bag is on sale). An add with giftBag: true puts ONE bag in the cart after the creation, unless one is already there.
 * Lot textiles (mission 2026-10-27-04) : { type: 'cdc-atelier-cart-lines-query', version: 1, requestId } is answered with
 * { type: 'cdc-atelier-cart-lines', version: 1, requestId, lines: [{ productId, quantity }] } (read only: no price, no personalisation). */
(function () {
  'use strict';
  var engineOrigin = 'https://portrait-animaux.compagnonsdecoeur.fr';
  var frame = document.querySelector('[data-cdc-atelier] iframe');
  if (!frame) return;
  var uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  var token = /^[A-Za-z0-9_-]{43}$/;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var cartUrl = root.replace(/\/$/, '') + '/cart';
  var operationPrefix = 'cdc-atelier-cart-op-v1:';
  var pending = new Set();
  var MAX_QUANTITY = 10;
  var queue = Promise.resolve();

  function pause(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  function send(payload) { frame.contentWindow.postMessage(payload, engineOrigin); }
  function remember(id, value) { try { if (value) sessionStorage.setItem(operationPrefix + id, JSON.stringify(value)); else sessionStorage.removeItem(operationPrefix + id); } catch (e) { /* private mode */ } }
  function recall(id) { try { return JSON.parse(sessionStorage.getItem(operationPrefix + id) || 'null'); } catch (e) { return null; } }
  async function cart() {
    var response = await fetch(cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart unavailable');
    return response.json();
  }
  function giftBag() {
    var bag = window.CDCGiftBag;
    return bag && /^\d{1,20}$/.test(String(bag.variantId)) && bag.available === true && Number.isSafeInteger(bag.priceCents) ? bag : null;
  }
  function bagLine(data) {
    var bag = giftBag();
    return bag && data.items.filter(function (item) { return String(item.variant_id) === String(bag.variantId); })[0] || null;
  }
  /** One bag with the creation, never a second one; a failure leaves the creation in the cart (the cart still offers the box). */
  async function addGiftBag(data) {
    var bag = giftBag();
    if (!bag || bagLine(data)) return data;
    try {
      await fetch(cartUrl + '/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(bag.variantId), quantity: 1 }] }) });
      return await cart();
    } catch (error) { console.warn('[cdc-atelier-cart] gift bag not added', error); return data; }
  }
  async function handleGiftBagQuery(message) {
    var answer = { type: 'cdc-atelier-gift-bag-info', version: 1, requestId: message.requestId, available: false, priceCents: null, inCart: false };
    var bag = giftBag();
    if (bag) {
      answer.available = true; answer.priceCents = bag.priceCents;
      try { answer.inCart = Boolean(bagLine(await cart())); } catch (error) { /* unknown: offered unticked */ }
    }
    send(answer);
  }
  async function handleLinesQuery(message) {
    var answer = { type: 'cdc-atelier-cart-lines', version: 1, requestId: message.requestId, lines: null };
    try {
      answer.lines = (await cart()).items.map(function (item) { return { productId: String(item.product_id), quantity: item.quantity }; });
    } catch (error) { /* unknown: no counter */ }
    send(answer);
  }
  function lineOf(data, creationId) {
    return data.items.filter(function (item) { return item.properties && item.properties._cdc_creation_id === creationId; })[0] || null;
  }
  function sameProperties(actual, expected) {
    actual = actual || {};
    var keys = Object.keys(expected);
    return keys.length === Object.keys(actual).length && keys.every(function (key) { return actual[key] === expected[key]; });
  }
  function validResolution(body, message) {
    var line = body && body.line;
    var props = line && line.properties;
    return body.requestId === message.requestId && body.creationId === message.creationId && line && /^\d{1,20}$/.test(String(line.id)) &&
      line.quantity === 1 && props && typeof props === 'object' && props._cdc_schema === '4' && props._cdc_creation_id === message.creationId &&
      /^[0-9a-f]{64}$/.test(props._cdc_signature || '') && body.expected && Number.isSafeInteger(body.expected.originalPriceCents);
  }
  async function refreshTheme(data) {
    try {
      if (window.theme && window.theme.Cart) { window.theme.Cart.setCurrentData(data); await window.theme.Cart.updateCart(); window.theme.Cart.showPopup(); }
    } catch (error) { console.warn('[cdc-atelier-cart] display deferred', error); }
  }

  async function handleAdd(message) {
    var result = { type: 'cdc-atelier-cart-result', version: 1, requestId: message.requestId, status: 'failed' };
    try {
      var before = await cart();
      if (lineOf(before, message.creationId)) {
        result.status = 'already_in_cart'; result.cartItemCount = before.item_count; remember(message.requestId, null);
        if (message.giftBag === true && !bagLine(before)) { var withBag = await addGiftBag(before); send(result); await refreshTheme(withBag); return; }
        send(result); return;
      }
      if (recall(message.requestId)) {
        // Replay of an add whose answer was lost: the line is not in the cart, so it was not added.
        remember(message.requestId, null); send(result); return;
      }
      var resolvedResponse = await fetch(engineOrigin + '/api/atelier/cart/resolve', { method: 'POST', credentials: 'omit', cache: 'no-store',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId: message.requestId, intentToken: message.intentToken }) });
      var resolved = await resolvedResponse.json().catch(function () { return {}; });
      if (!resolvedResponse.ok || !validResolution(resolved, message)) { result.status = 'rejected'; send(result); return; }
      var expected = resolved.line;
      remember(message.requestId, { creationId: message.creationId, startedAt: Date.now() });
      var response = null;
      try {
        response = await fetch(cartUrl + '/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(expected.id), quantity: 1, properties: expected.properties }] }) });
      } catch (e) { response = null; }
      if (response && !response.ok) { remember(message.requestId, null); result.status = 'rejected'; send(result); return; }
      var after = await cart();
      var added = lineOf(after, message.creationId);
      if (!added && !response) { await pause(5000); after = await cart(); added = lineOf(after, message.creationId); }
      remember(message.requestId, null);
      if (!added) { send(result); return; }
      if (String(added.variant_id) !== String(expected.id) || added.quantity !== 1 || !sameProperties(added.properties, expected.properties)) {
        // Never keep a line that differs from the signed one.
        await fetch(cartUrl + '/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: added.key, quantity: 0 }) }).catch(function () { return null; });
        result.status = 'rejected'; send(result); return;
      }
      if (message.giftBag === true) after = await addGiftBag(after);
      result.status = 'added'; result.cartItemCount = after.item_count;
      // Shopify is the price reference: a different price keeps the line and is reported to the Atelier.
      if (added.original_price !== resolved.expected.originalPriceCents) result.priceChanged = true;
      send(result);
      await refreshTheme(after);
    } catch (error) {
      send(result);
    }
  }

  async function handleIncrement(message) {
    var result = { type: 'cdc-atelier-cart-increment-result', version: 1, requestId: message.requestId, status: 'failed', quantity: null };
    try {
      var line = lineOf(await cart(), message.creationId);
      if (!line) { result.status = 'not_in_cart'; send(result); return; }
      if (line.quantity >= MAX_QUANTITY) { result.status = 'max'; result.quantity = line.quantity; send(result); return; }
      var response = await fetch(cartUrl + '/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity + 1 }) });
      var after = await cart();
      var updated = lineOf(after, message.creationId);
      if (response.ok && updated && updated.quantity === line.quantity + 1) { result.status = 'incremented'; result.quantity = updated.quantity; }
      send(result);
      await refreshTheme(after);
    } catch (error) { send(result); }
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== engineOrigin || event.source !== frame.contentWindow) return;
    var data = event.data;
    if (data && typeof data === 'object' && data.version === 1 && data.type === 'cdc-atelier-gift-bag-query') {
      if (uuid.test(data.requestId || '')) handleGiftBagQuery(data);
      return;
    }
    if (data && typeof data === 'object' && data.version === 1 && data.type === 'cdc-atelier-cart-lines-query') {
      if (uuid.test(data.requestId || '')) handleLinesQuery(data);
      return;
    }
    if (data && typeof data === 'object' && data.version === 1 && data.type === 'cdc-atelier-cart-increment') {
      if (!uuid.test(data.requestId || '') || !uuid.test(data.creationId || '') || pending.has(data.requestId)) return;
      pending.add(data.requestId);
      queue = queue.then(function () { return handleIncrement(data); }).finally(function () { pending.delete(data.requestId); });
      return;
    }
    if (!data || typeof data !== 'object' || data.version !== 1 || data.type !== 'cdc-atelier-cart-add') return;
    if (!uuid.test(data.requestId || '') || !uuid.test(data.creationId || '') || !token.test(data.intentToken || '')) return;
    if (data.giftBag !== undefined && data.giftBag !== true) return;
    if (pending.has(data.requestId)) return;
    pending.add(data.requestId);
    queue = queue.then(function () { return handleAdd(data); }).finally(function () { pending.delete(data.requestId); });
  });
})();
